import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const related = () => {
    new Swiper('.swiper-container-related', {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.swiper-related-next',
            prevEl: '.swiper-related-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
            },
        },
    });
};

export { related as default };
